import React from 'react';
import { Stack } from 'react-bootstrap';

function ClientDashboardProgressBar({ title, width }) {
  return (
    <div className="chart-card flex-grow-1">
      <div className="chart-title">{title}</div>
      <Stack className="chart-data" direction="horizontal">
        <div style={{ width: '80%' }}>
          <div className="progress-chart">
            <div className="chart-bar chart-bar-left chart-bar-left-recommend" style={{ width: `${width}%` }} />
            <div className="chart-bar chart-bar-right chart-bar-right-recommend" style={{ width: `${100 - width}%` }} />
          </div>
        </div>
        <div className="chart-bar-legend h-100">
          <div className="flex-column text-end">
            <div className="text-larger text-bolder">{`${width}%`}</div>
          </div>
        </div>
      </Stack>
    </div>
  );
}

export default ClientDashboardProgressBar;
